@if (loadingService.loading()) {
  <div class="spinner-overlay">
    <div class="spinner"></div>
  </div>
}
